import {clientStateGetters, computedGetters, serverStateGetters} from "./landerGetters";
import {landerMutations} from "./landerMutations";

const newLanderState = () => {
    return  {
        client: {
            landerApiUrl: null,
            upsellActionUrl: null,
            busy: false,
            loading: false,
            ready: false,
            showProspectForm: false,
            preAnimCompleted: false,
            spinCompleted: false,
            exitPopCompleted: false,
            exitPopCancelled: false,
            surveyCompleted: false,
            scrollTrackingPaused: false,
            ageVerified: false,
            merchantCss: '',
            merchantTheme: '',
            windowSize: {
                innerWidth: window.innerWidth,
                innerHeight: window.innerHeight
            },
            virtualOfferCode: null,
            disableUnloadHandler: false,
            userSubscribed: false,
            showTrustPilotBox: true
        },
        server: {
            product: {},
            lander: {},
            options: {},
            offer: {},
            benefits: {},
            currency: {},
            gateway: {},
            pixels: {},
            exitOffer: {},
            merchant: {},
            gift: null,
            social: {},
            info: {},
            spin: {
                mode: 0
            },
            prospect: {},
            primary: {},
            trustPilot: {}
        },
        socialAuth: null,
    }
}

export const landerModule = {
    state: () => {
        return {
            lander: newLanderState()
        }
    },
    getters: {...clientStateGetters, ...serverStateGetters, ...computedGetters,
        socialAuth: (state) =>  state.socialAuth,
        landerToken: (state) => { return sessionStorage.getItem('landerToken'); },
        loginToken: (state) => { return sessionStorage.getItem('loginToken'); },
    },
    mutations: {
        ...landerMutations,
        setSocialAuth: (state, auth) => { state.socialAuth = auth },
        clearSocialAuth: (state) => { state.socialAuth = null },
        setLanderToken: (state, token) => { if (token) { sessionStorage.setItem('landerToken', token); } },
        setLoginToken: (state, token) => { if (token) { sessionStorage.setItem('loginToken', token); } },
        clearLanderToken: (state, token) => { sessionStorage.removeItem('landerToken'); },
        clearLoginToken: (state, token) => { sessionStorage.removeItem('loginToken'); },
        clearLanderState: (state) => { state.lander = newLanderState();},
    }
}
